<template>
	<div id="top">
		<nav class="main-nav fix-on-scroll" :class="{ 'show-mobile-nav': showMobileNav }">
			<div class="row">
				<div class="columns column12">
					<div class="nav-bar">
						<nuxt-link class="logo" :to="{ path: localePath('/', locale), hash: '#top' }" />
						<div class="nav-content">
							<ul>
								<li class="menu-close" @click="hideMobileNav">
									<font-awesome-icon class="icon" icon="fal fa-times" size="1x" />
								</li>
								<li v-for="item in topmenu[locale]" :key="item.filename" @click="hideMobileNav">
									<nuxt-link :to="item.filename">
										{{ item.header }}
									</nuxt-link>
								</li>
								<li class="lang-nav mobile-only">
									<div v-for="item in langmenu" :key="item.filename" class="language">
										<nuxt-link
											class="flag"
											:class="item.language"
											:to="item.filename"
											@click="hideMobileNav"
										>
											<span>{{ $t(item.language) }}</span>
										</nuxt-link>
									</div>
								</li>
							</ul>
						</div>
						<div class="lang-section">
							<social-media :socials="socials" />
							<div v-if="page" class="language-navigation" @click="toggleLanguageMenu">
								<div v-if="langmenu.length" class="lang-select">
									<font-awesome-icon :icon="`fal fa-globe`" size="1x" />
									<span>{{ locale }}</span>
									<font-awesome-icon :icon="`fal fa-chevron-down`" size="1x" />
									<div class="lang-wrapper" :class="{ active: showLanguageMenu }">
										<div v-for="item in langmenu" :key="item.filename" class="language">
											<nuxt-link
												class="flag"
												:class="item.language"
												:to="item.filename"
												@click="hideMobileNav"
											>
												<span>{{ $t(item.language) }}</span>
											</nuxt-link>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="buttons">
							<div class="menu-button mobile-only" @click="toggleMobileNav">
								<font-awesome-icon class="icon" icon="fal fa-bars" size="1x" />
								<span>{{ $t('buttonMenu') }}</span>
							</div>
							<!--<book-button class="button book-now cta reserve-now">
								<font-awesome-icon class="icon" icon="fal fa-calendar-alt" size="1x" />
								<span>{{ $t('bookNow') }}</span>
							</book-button>-->
						</div>
					</div>
				</div>
			</div>
		</nav>
	</div>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, socials, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();

if (!defaults.value) {
	await fetchDefaults();
}

const showMobileNav = ref(false);
const showLanguageMenu = ref(false);

const { data: topmenu } = await useWebsiteFetch('topmenu');

const langmenu = computed(() => {
	return (page.value && page.value.langmenu) ?? [];
});

const toggleMobileNav = () => {
	showMobileNav.value = !showMobileNav.value;
};

const hideMobileNav = () => {
	showMobileNav.value = false;
};

const toggleLanguageMenu = () => {
	showLanguageMenu.value = !showLanguageMenu.value;
};
</script>

<style lang="scss" scoped>
.mobile-only {
	display: none !important;
}

.main-nav {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: none;
	transition: all 0.3s ease-in-out;

	&.fixed {
		background: var(--footer-background-color);
		box-shadow: 0 0 20px rgba(0 0 0 / 10%);

		.logo {
			margin: 8px 0;
		}
	}

	ul li {
		display: inline-block;
	}
}

.no-heading-image {
	.main-nav {
		background: var(--footer-background-color);
		box-shadow: 0 0 20px rgba(0 0 0 / 10%);

		.logo {
			margin: 8px 0;
		}
	}
}

.nav-bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 0;
	z-index: 9;
	position: relative;

	.buttons {
		display: flex;
		align-items: center;
		gap: 10px;

		.button {
			padding: 15px 25px;
			margin: 0;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.icon {
			display: none;
			margin-right: 5px;
		}
	}
}

.lang-section {
	display: flex;
	flex-flow: row nowrap;
	place-items: center center;
}

.logo {
	padding: 0;
	text-decoration: none;
	margin: 20px 0;
	background: url('~/assets/images/logo-cafe-verlan-grey-full.png') no-repeat center center;
	background-size: 170px;
	width: 170px;
	height: 64px;
}

.nav-content {
	a {
		text-decoration: none;
		margin: 0 10px;
		padding: 3px 1px;
		color: #fff;
		letter-spacing: 1px;
		font-size: 18px;
		text-transform: uppercase;
		font-weight: 700;
		border-bottom: 2px solid rgba(0 0 0 / 0%);
		font-family: var(--heading-font-family);

		&.active,
		&:hover {
			color: var(--cta-color);
			border-color: var(--cta-color);
		}
	}

	.menu-close {
		color: #fff;
		display: none;
		font-size: 30px;
		cursor: pointer;
		position: absolute;
		top: 15px;
		width: auto;
		right: 20px;
		padding: 0;
		margin: 0;
	}
}

.lang-nav {
	margin: 0 0 25px;

	.language {
		margin: 20px 0;

		.flag::before {
			content: '';
			width: 20px;
			position: relative;
			top: 3px;
			height: 20px;
			margin: 2px 9px -1px 0;
			display: inline-block;
		}

		.flag.en::before {
			background: url('~/assets/images/en.png') no-repeat;
			background-size: 20px;
		}

		.flag.nl::before {
			background: url('~/assets/images/nl.png') no-repeat;
			background-size: 20px;
		}

		.flag.de::before {
			background: url('~/assets/images/de.png') no-repeat;
			background-size: 20px;
		}

		.flag.fr::before {
			background: url('~/assets/images/fr.png') no-repeat;
			background-size: 20px;
		}

		.flag.es::before {
			background: url('~/assets/images/es.png') no-repeat;
			background-size: 20px;
		}
	}

	img {
		width: 16px;
		float: left;
		margin: 0 5px 0 0;
	}

	a {
		width: 100%;
		float: left;
		color: var(--body-color);
		text-decoration: none;
		margin: 4px 0;
		text-transform: uppercase;

		&.active {
			color: var(--cta-color);
		}
	}
}

.language-navigation:hover .lang-nav-sel,
.language-navigation:hover .fa-globe {
	color: var(--cta-color);
}

.lang-nav-sel {
	box-shadow: none;
	cursor: pointer;
	width: 30px;
	padding: 0 4px 0 0;
	color: #fff;
	border: none;
	text-transform: uppercase;
	font-size: 12px;
	font-family: sans-serif;
	appearance: none;
	background: url('~/assets/images/dropdown.png') right 1px center no-repeat;
	background-size: 7px;
	transition: color 0.3s ease-in-out;

	option {
		color: var(--body-color);
	}

	&::-ms-expand {
		display: none;
	}
}

.lang-select {
	padding: 8px 20px;
	margin: 0 10px;
	border-left: 1px solid #e5e5e5;
	position: relative;
	cursor: pointer;
	text-transform: uppercase;
	font-size: 16px;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;

	span {
		margin: 0 4px;
	}

	a {
		text-decoration: none;
	}

	svg {
		font-size: 16px;
	}
}

.lang-wrapper {
	display: none;
	position: absolute;
	top: 35px;
	left: 3px;
	right: 3px;
	padding: 10px 9px;
	text-align: center;
	background: var(--primary-background-color);
	box-shadow: 0 18px 18px rgb(0 0 0 / 10%);
	z-index: 90;

	&.active,
	a {
		display: flex;
		flex-flow: column nowrap;
		place-content: space-between flex-start;
		text-align: left;
		color: #000 !important;
		font-size: 13px;
		gap: 5px;
	}

	a {
		width: 100%;
		flex-direction: row;
	}

	img {
		width: 16px;
		height: 16px;
		margin: 2px 0 0;
	}
}

.language-navigation {
	color: #fff;

	option {
		color: var(--body-color);
	}

	.fa-globe {
		margin: 0 2px 0 0;
		color: #fff;
		transition: color 0.3s ease-in-out;
	}
}

@media (max-width: 1280px) {
	.nav-bar a {
		font-size: 14px;
	}
}

@media (max-width: 1200px) {
	.menu-button {
		text-transform: uppercase;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: space-between;
		margin: 0 10px 0 0;
		color: #fff;
		cursor: pointer;

		svg {
			font-size: 22px;
		}

		span {
			margin: 0 0 0 5px;
		}
	}

	.nav-content {
		width: 50%;
	}

	.mobile-only {
		display: flex !important;

		&.lang-nav {
			display: inline-block !important;
			margin: 40px 0 0;
			padding: 0 10px;
		}
	}

	.language-navigation {
		display: none;
	}

	.lang-nav {
		display: flex;
		flex-flow: column wrap;

		.language {
			width: 100%;
			display: inline-block;
			margin: 0;
		}

		a {
			color: #fff;
			width: auto;
			margin: 0;
			border: none;
			padding: 0;
		}
	}

	.nav-bar .buttons .icon {
		display: unset;
	}

	.main-nav {
		position: fixed !important;
		top: 0;
		box-shadow: 0 0 10px rgb(0 0 0 / 10%);

		&.show-mobile-nav {
			.nav-content ul {
				display: flex;
				flex-direction: column;
				justify-content: center;
				opacity: 1;
				visibility: visible;
				transition: opacity 0.3s ease-in-out;

				li:not(.menu-close) {
					width: 100%;
				}

				li:not(.lang-nav, .menu-close) {
					margin: 7px 0;

					a {
						font-size: 20px;
					}
				}
			}
		}

		ul {
			position: fixed;
			inset: 0;
			background: rgba(0 32 91 / 90%);
			text-align: left;
			padding: 20px;
			opacity: 0;
			visibility: hidden;
			overflow-y: scroll;
		}
	}

	.nav-content .menu-close {
		display: block;
	}
}

@media (max-width: 880px) {
	.nav-bar .buttons {
		.button {
			padding: 16px;
		}

		.menu-button {
			margin-right: 5px;

			.icon {
				font-size: 22px;
			}
		}

		.icon {
			margin-right: 0;
			font-size: 16px;
		}

		span {
			display: none;
		}
	}

	.nav-content {
		width: calc(50% - 120px);
	}
}

@media (max-width: 580px) {
	.nav-bar .buttons span {
		display: none;
	}
}
</style>
